import React, { useEffect, useRef, useState } from 'react';

import { FlatTree, motion } from 'framer-motion';
export default function Potenciometro() {
  const [graus, setGraus] = useState(0);
  const refSeta = useRef(null);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [valor, setValor] = useState(0);
  useEffect(() => {
    const update = (e) => {
      setMouse({ x: e.x, y: e.y });
    };
    window.addEventListener('mousemove', update);
    window.addEventListener('touchmove', update);
    return () => {
      window.removeEventListener('mousemove', update);
      window.removeEventListener('touchmove', update);
    };
  }, [setMouse]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: 'purple',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 500,
          height: 500,
          backgroundColor: 'blue',
          flexDirection: 'column',
        }}
        onClickCapture={(e) => {
          let x1 = e.clientX.toFixed(2),
            y1 = e.clientY.toFixed(2),
            x2 =
              refSeta.current.getBoundingClientRect().x +
              refSeta.current.getBoundingClientRect().width / 2,
            y2 =
              refSeta.current.getBoundingClientRect().y +
              refSeta.current.getBoundingClientRect().height;
          let calculo = (x1 - x2) / Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
          let pot = 0;
          console.log((Math.acos(calculo) * 180) / Math.PI);

          setValor((((Math.acos(calculo) * 180) / Math.PI - 0) * (100 - 0)) / (180 - 0));
          setGraus((Math.acos(calculo) * 180) / Math.PI);
        }}
      >
        <h1>{100 - valor.toFixed(0)}</h1>
        <div
          ref={refSeta}
          style={{
            display: 'flex',
            backgroundColor: 'green',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <motion.img
            height={50}
            width={50}
            animate={{ scale: 1, rotate: -graus, x: 25, y: 25, originY: 0.5, originX: 0 }}
            transition={{ duration: 0.3 }}
            src={require('../Icones/setaTeste.svg.svg').default}
          />
        </div>
        <h1>
          X:{mouse.x} Y:{mouse.y}
        </h1>
      </div>
      <button
        onClick={() => {
          setGraus(graus + 5);
        }}
      >
        teste
      </button>
    </div>
  );
}
